/**
 * Derived usage-limit alerts for admin banners (B3.3).
 * Approaching (≥ warn threshold) and exceeded — dismiss is client-local.
 */
import { get } from '@core/api/client';
import { endpoints } from '@core/api/endpoints';

export type BillingAlertSeverity = 'approaching' | 'exceeded';

export interface BillingAlert {
  id: string;
  severity: BillingAlertSeverity;
  code: string;
  message: string;
  tenantId: string;
  agentId: string | null;
  scope: string;
  period: string;
  metric: string;
  pool: string;
  used: number;
  limitValue: number;
  remaining: number;
  percentUsed: number;
  warnThresholdPct: number;
  setByEffective: string;
}

export interface TenantBillingAlertsResult {
  tenantId: string;
  now: string;
  alerts: BillingAlert[];
}

export interface PlatformBillingAlertsResult {
  now: string;
  alerts: BillingAlert[];
}

export const billingAlertsService = {
  tenant(): Promise<TenantBillingAlertsResult> {
    return get<TenantBillingAlertsResult>(endpoints.billingAlerts.list);
  },

  platform(params?: {
    tenantId?: string | null;
  }): Promise<PlatformBillingAlertsResult> {
    const qs =
      params?.tenantId != null && params.tenantId !== ''
        ? `?tenantId=${encodeURIComponent(params.tenantId)}`
        : '';
    return get<PlatformBillingAlertsResult>(
      `${endpoints.platformBillingAlerts.list}${qs}`,
    );
  },
};
